module.exports = __webpack_public_path__ + "static/media/emptyPending.4bcde091.svg";